<div class="flex justify-center items-center flex-col py-[87px]">
    <img src="assets/images/404.svg" alt="404 Error" class="mb-[50px] size-[250px]" />
    <h3 class="font-medium text-[54px] leading-[105px] text-[#000000] mb-2.5">
    404 Page Not Found
    </h3>
    <p class="font-medium text-base leading-normal text-[#424242] mb-[30px]">
   This page doesn’t exist or may have been moved.
    </p>
    <button (click)="navigate()"
        class=" bg-black text-white font-medium text-base leading-normal rounded-[4px] py-[15px] px-[25px]">Back
        to Home</button>
</div> 